import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

/**
 * Shown in place of the form once a save lands.
 *
 * The Operations layer spans four screens: an operation does nothing until a machine
 * declares it as a Capability and a part puts it in its Route, and a run only reports
 * once both exist. None of that ordering is visible on the page the user is standing on,
 * so a save used to close the panel and leave them guessing where to go.
 *
 * Each step names the destination and spells out the click path to it, so the sequence
 * is learnable rather than something to be followed blindly every time.
 */
const SaveSuccessPanel = ({
    heading,
    subheading,
    steps = [],
    onNavigate,
}) => (
    <div className="py-2">
        <div className="text-center mb-4">
            <CheckCircleIcon
                className="text-success"
                style={{ fontSize: "3rem" }}
            />
            <h5 className="mt-2 mb-1">{heading}</h5>
            {subheading && (
                <div className="text-muted small">{subheading}</div>
            )}
        </div>

        <div className="text-uppercase text-muted small fw-semibold mb-2">
            What to do next
        </div>

        {steps.map((step, index) => (
            <button
                key={step.to + index}
                type="button"
                className="btn btn-light border w-100 text-start d-flex align-items-center gap-3 p-3 mb-2"
                onClick={() => onNavigate(step.to)}
            >
                <span
                    className="badge rounded-circle bg-success-subtle text-success flex-shrink-0 d-flex align-items-center justify-content-center"
                    style={{ width: "28px", height: "28px" }}
                >
                    {index + 1}
                </span>

                <span className="flex-grow-1">
                    <div className="fw-semibold">{step.label}</div>
                    {step.why && (
                        <div className="text-muted small">{step.why}</div>
                    )}
                    {step.path?.length > 0 && (
                        <div className="small text-primary mt-1">
                            {step.path.join("  ›  ")}
                        </div>
                    )}
                </span>

                <ChevronRightIcon
                    fontSize="small"
                    className="text-muted flex-shrink-0"
                />
            </button>
        ))}
    </div>
);

export default SaveSuccessPanel;
